// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import {
  StyledMobileBoxItem,
  StyledMobileBoxItemRow,
  StyledMobileBoxLabel,
  StyledMobileBoxRemoveButton,
} from '../../utils/Styles/DataBoxStyles';
import MemberStatus from './MemberStatus';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const MemberInfoMobile = ({ members, toUser, onRemoveClick }) => {
  return (
    <div>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      {members.map(member => (
        <StyledMobileBoxItem
          key={member.memberId}
          onClick={() => toUser(member.memberId)}
        >
          <StyledMobileBoxLabel right='40px'>
            <MemberStatus text={member.status} />
          </StyledMobileBoxLabel>
          {/* TODO: Fix this the next time the file is edited. */}
          {/* eslint-disable-next-line react/prop-types */}
          {members.length !== 1 && (
            <StyledMobileBoxRemoveButton
              onClick={onRemoveClick}
              data-member-id={member.memberId}
              data-member-name={member.memberName}
            />
          )}
          <StyledMobileBoxItemRow>
            Username: <span>{member.memberName}</span>
          </StyledMobileBoxItemRow>
          <StyledMobileBoxItemRow maxWidth='100%'>
            Email: <span>{member.memberEmail}</span>
          </StyledMobileBoxItemRow>
          <StyledMobileBoxItemRow maxWidth='100%'>
            Phone: <span>{member.memberPhone}</span>
          </StyledMobileBoxItemRow>
          <StyledMobileBoxItemRow maxWidth='100%'>
            Role: <span>{member.memberRole}</span>
          </StyledMobileBoxItemRow>
        </StyledMobileBoxItem>
      ))}
    </div>
  );
};

export default MemberInfoMobile;
